import { Component, Input, OnInit } from '@angular/core';
import { take } from 'rxjs/operators';
import { UserSantanderService } from '../../services/users/user-santander.service';
import { DialogsService } from '../../services/dialogs.service';
import { SantanderGuaranteeIncreaseModalComponent } from '../santander-guarantee-increase-modal/santander-guarantee-increase-modal.component';

@Component({
    selector: 'hub-santander-banner',
    templateUrl: './santander-banner.component.html',
    styleUrls: ['./santander-banner.component.scss']
})
export class SantanderBannerComponent implements OnInit {
    @Input() cblcId: string;

    public showBanner: boolean = false;

    constructor(
        private userSantanderService: UserSantanderService,
        private dialogsService: DialogsService
    ) { }

    ngOnInit(): void {
        if (this.cblcId) {
            this.checkSantanderBanner(this.cblcId);
        }
    }

    private checkSantanderBanner(cblcId: string): void {
        this.userSantanderService
            .getSantanderOperationalLimit(cblcId)
            .pipe(take(1))
            .subscribe((limit) => {
                this.showBanner = limit.isSantanderCustomer() && !limit.hasAcceptedTerms();
            });
    }

    public openSantanderModal(): void {
        this.dialogsService.showComponentAsAsidePanel(
            SantanderGuaranteeIncreaseModalComponent,
            true,
        );
    }
}
